module.exports = __webpack_public_path__ + "static/media/mobiles.325bc4d3.png";